import { APP_NAME } from '../constants'

export const createActionType = (componentName = '', actionType = '') =>
  `${APP_NAME}/${componentName}/${actionType}`

export const createRequestActionTypes = (componentName = '', base = '') => {
  const res = {}

  if (
    componentName === '' ||
    base === '' ||
    componentName === null ||
    base === null
  ) {
    console.warn(
      'createRequestActionTypes() componentName or base' +
        'arguments are not provided'
    )
  }

  ;['REQUEST', 'SUCCESS', 'FAILURE'].forEach(
    (type) => (res[type] = createActionType(componentName, `${base}_${type}`))
  )

  return res
}
